import { cn } from '@/shared/lib/cn';

/**
 * Exact Figma dashed stroke (`dash [4, 4]`, 1 px, inside) — CSS `border-dashed` draws browser-specific dash lengths.
 * Absolutely positioned over its `relative` parent; colour via `currentColor` (`className="text-white-300"`).
 * Geometry uses CSS properties (`width`, `rx`) so the corner radius follows the rem-scaled UI.
 */
export function DashedOutline({ radius, dash = '4 4', className }: { radius: number | 'full'; dash?: string; className?: string }) {
  const r = radius === 'full' ? '50%' : `${radius / 16}rem`;
  return (
    <svg aria-hidden className={cn('pointer-events-none absolute inset-0 size-full overflow-visible', className)}>
      <rect
        x="0.5"
        y="0.5"
        fill="none"
        stroke="currentColor"
        strokeWidth="1"
        strokeDasharray={dash}
        style={{ width: 'calc(100% - 1px)', height: 'calc(100% - 1px)', rx: r, ry: r } as React.CSSProperties}
      />
    </svg>
  );
}
